import styled from 'styled-components'

export const AreaSidebar = styled.div`

/* espaço de 10% da tela do menu */

  position:absolute;
  width: 5%;
  left:0;
  display: flex;
  flex-direction:column;
  gap:20px;
  text-align:center;
    align-items:center;
  height:90%;
  bottom:5%;
  /* background-color: red; */
  border-radius:100px;


/* menu esquerdo superior com 4 items */
   div {
    position:relative;
    list-style: none;
    width:60px;
    height:60px;
    display:flex;
    align-items:center;
    justify-content:center;
    /* background-color:purple; */
    border-radius:50%;
    border:none;
}
  div:hover {
      justify-content: center;
      align-items: center;
      width: 100%
      border-radius: 50px;
      filter: invert(47%) sepia(95%) saturate(1092%) hue-rotate(82deg) brightness(117%) contrast(125%);
    }
    div:focus-within {
      filter: invert(47%) sepia(95%) saturate(1092%) hue-rotate(82deg) brightness(117%) contrast(125%);
  }
  li{
    display:none;
  }


/* botão inferior esquerdo de logout */
  .espaçoMenu {
    position:absolute;
    bottom:0;
    list-style: none;
    width:60px;
    height:60px;
    display:flex;
    align-items:center;
    justify-content:center;
    /* background-color:purple; */
    border-radius:50%;
    :hover {
      justify-content: center;
      align-items: center;
      width: 100%
      border-radius: 50px;
      filter: invert(47%) sepia(95%) saturate(1092%) hue-rotate(82deg) brightness(117%) contrast(125%);
    }
  }
      /* logo do espaço esquerdo */
.logoMenu{
    position: absolute;
    top:0;
  background: cover/center;
  /* z-index: -1; */
  transition: all 0.3s ease-in-out;
}
 @media screen and (max-width:820px){
  /* espaço de 10% da tela do menu */

  position:absolute;
  width: 100%;
  left:0;
  display: flex;
  flex-direction:row;
  gap:6%;
  text-align:center;
    align-items:center;
  height:10%;
  bottom:0%;
  /* background-color: red; */
  border-radius:100px;
 
/* menu esquerdo superior com 4 items */

div {
    position:relative;
    list-style: none;
    width:55px;
    height:55px;
    display:flex;
    align-items:center;
    justify-content:center;
    /* background-color:purple; */
    border-radius:50%;
}
  div:hover {
      justify-content: center;
      align-items: center;
      width: 100%
      border-radius: 50px;
      transition: all 0.3s ease-in-out;
      filter: invert(0%) sepia(79%) saturate(2476%) hue-rotate(86deg);
    }
    div:focus-within {
  filter: invert(0%) sepia(79%) saturate(2476%) hue-rotate(86deg);
  }
  

/* botão inferior esquerdo de logout */
.espaçoMenu {
    position: absolute;
    display: flex;
    flex-direction:row;
    bottom:5%;
    right:0;
    width: 20%;
    height:90%;
    /* background-color:purple; */
    :hover {
      width: 100%
      border-radius: 50px;
      transition: all 0.3s ease-in-out;
      filter: invert(0%) sepia(79%) saturate(2476%) hue-rotate(86deg);
    }
  }
      /* logo do espaço esquerdo */
.logoMenu{
    position: absolute;
  background: cover/center;
  z-index: -1;
  transition: all 0.3s ease-in-out;
}
  }


`
export const MenuProfileDireita = styled.div`
  position: fixed;
  display: fixed;
  align-items: center;
  justify-content: center;
  top: 35%;
  left: 78%;
  width: 18%;
  height: 250px;
  border-radius: 20px;

  .UlMenuProfileDireita {
    position: absolute;
    width: 100%;
    height: 100%;
    /* background-color: red; */
  }
  li {
    justify-content: center;
    align-items: center;
    list-style: none;
    text-align: center;
    &:focus-within {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
    }
  }
  .ttlBtnNav1 {
    width: 100%;
    height: 15%;
    position: absolute;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    top: 0px;
    font: clamp(0.01em, 0.01em + 1.4vw, 2em) Roboto-Bold;
    background-color: #fff;
    color: #077e1a;
    border: 1px solid #077e1a;
    border-radius: 5px;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      color: rgb(255, 255, 255);
      background-color: #077e1a;
      transition: all 0.3s ease-in-out;
    }
    &:focus-within {
      color: rgb(255, 255, 255);
      background-color: #077e1a;
    }
  }

  .ttlBtnNav2 {
    position: absolute;
    top: 20%;
    width: 100%;
    height: 15%;
    left: 0;
    font: clamp(0.01em, 0.01em + 1.4vw, 2em) Roboto-Bold;
    padding-top: 1%;
    background-color: #fff;
    color: #077e1a;
    border: 1px solid #077e1a;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      color: rgb(255, 255, 255);
      background-color: #077e1a;
      transition: all 0.3s ease-in-out;
    }
    &:focus-within {
      color: rgb(255, 255, 255);
      background-color: #077e1a;
    }
  }
  .ttlBtnNav3 {
    position: absolute;
    top: 40%;
    left: 0;
    width: 100%;
    height: 15%;
    font: clamp(0.01em, 0.01em + 1.4vw, 2em) Roboto-Bold;
    padding-top: 1%;
    border: 1px solid #077e1a;
    border-radius: 5px;
    cursor: pointer;
    background-color: #fff;
    color: #077e1a;
    border: 1px solid #077e1a;
    &:hover {
      color: rgb(255, 255, 255);
      background-color: #077e1a;
      transition: all 0.3s ease-in-out;
    }
  }
  .ttlBtnNav4 {
    position: absolute;
    top: 60%;
    right: 0px;
    width: 100%;
    height: 15%;
    font: clamp(0.01em, 0.01em + 1.4vw, 2em) Roboto-Bold;
    padding-top: 1%;
    border: 1px solid #077e1a;
    border-radius: 5px;
    cursor: pointer;
    background-color: #fff;
    color: #077e1a;
    border: 1px solid #077e1a;
    &:hover {
      color: rgb(255, 255, 255);
      background-color: #077e1a;
      transition: all 0.3s ease-in-out;
    }
  }
  .ttlBtnNav5 {
    position: absolute;
    top: 80%;
    right: 0px;
    width: 100%;
    height: 15%;
    font: clamp(0.01em, 0.01em + 1.4vw, 2em) Roboto-Bold;
    padding-top: 1%;
    border: 1px solid #077e1a;
    border-radius: 5px;
    cursor: pointer;
    background-color: #fff;
    color: #077e1a;
    &:hover {
      color: rgb(255, 255, 255);
      background-color: #077e1a;
      transition: all 0.3s ease-in-out;
    }
  }
  .ttlBtnNav9 {
    position: absolute;
    top: 80%;
    width: 100%;
    height: 15%;
    font: clamp(0.01em, 0.01em + 1.4vw, 2em) Roboto-Bold;
    padding-top: 1%;
    border: none;
    background-color: #fff;
    color: rgb(0, 0, 0);
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  @media screen and (max-width: 820px) {
    position: fixed;
    display: fixed;
    align-items: center;
    top: 20%;
    left: 70%;
    width: 30%;
    height: 70%;
    border-radius: 0px;
    background: #e4e4e4;
    .UlMenuProfileDireita {
      position: absolute;
      width: 80%;
      height: 60%;
      /* background-color: red; */
    }
    li {
      margin-top: 10%;
      justify-content: center;
      align-items: center;
      list-style: none;
      text-align: center;
      &:focus-within {
        color: rgb(255, 255, 255);
        background-color: #0b9e82;
      }
      &:hover {
        color: rgb(255, 255, 255);
        background-color: #0b9e82;
        transition: 0.6s;
      }
    }
    /* nav ul li  */
    .tttlBtnNav1 {
      width: 90%;
      height: 8%;
      position: absolute;
      display: flex;
      justify-content: center;
      text-align: center;
      align-items: center;
      top: 26%;
      left: 5%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      font-family: Roboto-Bold;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
      border-radius: 5px;
      cursor: pointer;
      text-decoration: none;
    }
    .tttlBtnNav1:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav2 {
      position: absolute;
      top: 36%;
      width: 90%;
      left: 5%;
      height: 8%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      font-family: Roboto-Bold;
      padding-top: 1%;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    .tttlBtnNav2:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav3 {
      position: absolute;
      top: 46%;
      left: 5%;
      width: 44%;
      height: 8%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      font-family: Roboto-Bold;
      padding-top: 1%;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
    }
    .tttlBtnNav3:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav4 {
      position: absolute;
      top: 46%;
      right: 5%;
      width: 44%;
      height: 8%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      font-family: Roboto-Bold;
      padding-top: 1%;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
    }
    .tttlBtnNav4:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav5 {
      position: absolute;
      top: 46%;
      left: 5%;
      width: 44%;
      height: 8%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      font-family: Roboto-Bold;
      padding-top: 1%;
      border: none;
      margin-right: 10px;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    .tttlBtnNav5:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav6 {
      position: absolute;
      top: 46%;
      right: 5%;
      width: 44%;
      height: 8%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      font-family: Roboto-Bold;
      padding-top: 1%;
      border: none;
      margin-bottom: 5px;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    .tttlBtnNav6:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav7 {
      position: absolute;
      top: 56%;
      left: 5%;
      width: 44%;
      height: 8%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      font-family: Roboto-Bold;
      padding-top: 1%;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      margin-bottom: 10px;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
    }
    .tttlBtnNav7:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav8 {
      position: absolute;
      top: 56%;
      right: 5%;
      width: 44%;
      height: 8%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      font-family: Roboto-Bold;
      padding-top: 1%;
      border: none;
      margin-bottom: 10px;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    .tttlBtnNav8:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav9 {
      position: absolute;
      top: 56%;
      left: 5%;
      width: 90%;
      height: 8%;
      font-size: clamp(0.01em, 0.01em + 1.6vw, 2em);
      padding-top: 1%;
      border: none;
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    .tttlBtnNav9:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav1:focus-within {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
    .tttlBtnNav1:hover {
      color: rgb(255, 255, 255);
      background-color: #0b9e82;
      transition: 0.6s;
    }
  }

  @media screen and (max-width: 620px) {
    display: none;
  }
`
